import {toString} from 'lodash';
import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';

dayjs.extend(utc);

export function currentTimeUnix(): number {
    return toMilliseconds(dayjs().unix());
}

export function toMilliseconds(time: number | string | Date): number {
    if (typeof time !== 'number') {
        return 0;
    }
    return time * 1000;
}

export function toUtc(date: Date): string {
  return dayjs.utc(date).format();
}

export function addDigit(value: number): string {
    if (value < 10) {
        return `0${value}`;
    }
    return toString(value);
}
